import $ from 'jquery';
import numeral from 'numeral';
import { Howl } from 'howler';
import moment from 'moment';
import XLSX from 'xlsx';

import Config from './config.js';

import alertSound from '../sounds/alert-1.m4a';
import successSound from '../sounds/success-1.m4a';
import errorSound from '../sounds/error-1.m4a';

let Utils = {};

Utils.compareTwoObjectsByInsurer = function(a, b) {
  let newPremiumRates = [];
  for (let i = 0; i < a.length; i++) {
    for (let j = 0; j < b.length; j++) {
      if (a[i].insurer === b[j].insurer) {
        newPremiumRates.push(b[j]);
      }
    }
  }
  return newPremiumRates;
};

Utils.getConveyanceType = function(conveyance) {
  if (conveyance === Config.CONVEYANCE.AIR) {
    return 'AIR';
  } else if (conveyance === Config.CONVEYANCE.SEA) {
    return 'SEA';
  } else {
    return '-';
  }
};

/* Return formatted amount rounded off to 2 decimal places */
Utils.parseAmount = function(amount) {
  let parsedAmount = parseFloat(amount).toFixed(2);
  return numeral(parsedAmount).format('0,0.00');
};

Utils.toFixedDown = function(digits) {
  let re = new RegExp('(\\d+\\.\\d{' + digits + '})(\\d)'),
    m = this.toString().match(re);
  return m ? parseFloat(m[1]) : this.valueOf();
};

Utils.groupBy = function(objArray, key) {
  let groupsObj = objArray.reduce(function(obj, item) {
    obj[item[key]] = obj[item[key]] || [];
    obj[item[key]].push(item);
    return obj;
  }, {});

  let groups = Object.keys(groupsObj).map(function(value, index) {
    return { section: value, section_items: groupsObj[value] };
  });

  return groups;
};

Utils.filterOtherRatesByInsurer = function(objArray, insurer_id) {
  return $.grep(objArray, function(insurer, i) {
    return insurer.insurer === insurer_id;
  })[0];
};

// Sum Values in an Array
Utils.sum = function(items, prop) {
  if (typeof items !== 'undefined') {
    return items.reduce(function(a, b) {
      return numeral(a).value() + numeral(b[prop]).value();
    }, 0);
  } else {
    return 0;
  }
};

// Round up to the nearest 5
Utils.round5 = function(x) {
  return Math.ceil(x / 5) * 5;
};
Utils.removeCommas = function(str) {
  while (str.search(',') >= 0) {
    str = (str + '').replace(',', '');
  }
  return parseInt(str, 10);
};
// Check if an object isEmpty
Utils.isEmpty = function(obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};

// Sound notifications
Utils.notify = function(type, message = '') {
  let sound = alertSound;

  switch (sound) {
    case 'success':
      sound = successSound;
      break;

    case 'error':
      sound = errorSound;
      break;

    default:
      sound = alertSound;
  }

  let player = new Howl({
    src: sound
  });

  player.play();
};

Utils.isEmailAddress = function(email) {
  let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email.toLowerCase());
};
Utils.isTRA = function(tra) {
  let regex = /([0-9]{3}-[0-9]{3}-[0-9]{3,4})/;
  return regex.test(tra.toUpperCase());
};
Utils.sheetToJson = workbook => {
  let result = {};
  workbook.SheetNames.forEach(function(sheetName) {
    let roa = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName], {
      dateNF: 'YYYY-MM-DD',
      defval: ''
    });
    if (roa.length > 0) {
      result[sheetName] = roa;
    }
  });
  return JSON.stringify(result, 2, 2);
};
Utils.to_json = workbook => {
  let result = {};
  let roa = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
    dateNF: 'YYYY-MM-DD',
    defval: ''
  });
  if (roa.length) result = roa;
  return JSON.stringify(result, 2, 2);
};
Utils.checkArray = (obj, keys) => {
  return (
    obj.filter(object => {
      return keys.map(key => object.hasOwnProperty(key)).indexOf(false) == -1;
    }).length === obj.length
  );
};
Utils.prep = arr => {
  let out = [];
  for (let i = 0; i < arr.length; ++i) {
    if (!arr[i]) continue;
    if (Array.isArray(arr[i])) {
      out[i] = arr[i];
      continue;
    }
    let o = new Array();
    Object.keys(arr[i]).forEach(function(k) {
      o[+k] = arr[i][k];
    });
    out[i] = o;
  }
  return out;
};
Utils.ucFirst = function(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
Utils.endOfYear = () => {
  let beginingOfYear = moment().startOf('year');
  return beginingOfYear
    .clone()
    .endOf('year')
    .format('YYYY-MM-DD hh:mm');
};

Utils.getTimeRanges = () => {
  const today = moment().format('YYYY-MM-DD');
  const startOfWeek = moment()
    .startOf('isoWeek')
    .format('YYYY-MM-DD');

  return {
    today,
    startOfWeek,
    last_7days:
      moment()
        .subtract(7, 'days')
        .format('YYYY-MM-DD') +
      ' - ' +
      today,
    last_30days:
      moment()
        .subtract(30, 'days')
        .format('YYYY-MM-DD') +
      ' - ' +
      today,
    last_3months:
      moment()
        .subtract(3, 'months')
        .format('YYYY-MM-DD') +
      ' - ' +
      today,
    last_6months:
      moment()
        .subtract(6, 'months')
        .format('YYYY-MM-DD') +
      ' - ' +
      today,
    last_12months:
      moment()
        .subtract(12, 'months')
        .format('YYYY-MM-DD') +
      ' - ' +
      today
  };
};

export default Utils;



// WEBPACK FOOTER //
// ./src/utils/mci-utils.js